module.exports = __webpack_public_path__ + "aef3cdc47693928838c1f67a12b7297a.svg";